import { useEffect, useState } from 'react'
import { api } from '../api.js'

export default function Envois({ onOuvrir }) {
  const [liste, setListe] = useState([])
  const [ouvert, setOuvert] = useState(null)

  useEffect(() => { api.outbox().then(setListe) }, [])

  return (
    <>
      <h1>Envois</h1>
      <p className="chapo">Trace de tout ce que la plateforme a expédié, dossier par dossier.</p>

      <table className="tableau">
        <thead>
          <tr><th>Date</th><th>Destinataire</th><th>Objet</th><th>Dossier</th><th>État</th></tr>
        </thead>
        <tbody>
          {liste.map((m) => (
            <tr key={m.id} onClick={() => setOuvert(ouvert === m.id ? null : m.id)} tabIndex={0}
                onKeyDown={(e) => e.key === 'Enter' && setOuvert(ouvert === m.id ? null : m.id)}>
              <td className="mono">{new Date(m.at).toLocaleString('fr-FR')}</td>
              <td>{m.channel === 'sms' && <span className="tag">SMS</span>} {m.to}</td>
              <td><strong>{m.subject}</strong></td>
              <td className="mono">{m.number}</td>
              <td>
                {m.sent ? <span className="ok">envoyé</span>
                  : m.error ? <span className="probleme">{m.error}</span>
                  : <span className="tag">en attente</span>}
              </td>
            </tr>
          ))}
          {!liste.length && <tr><td colSpan={5} className="vide">Rien n'est encore parti.</td></tr>}
        </tbody>
      </table>

      {ouvert && (() => {
        const m = liste.find((x) => x.id === ouvert)
        return (
          <section className="carte">
            <h2>{m.subject}</h2>
            <p className="aide">À {m.to} · {new Date(m.at).toLocaleString('fr-FR')}</p>
            <pre className="apercu-mail">{m.body}</pre>
            {m.request_id && (
              <button className="btn" onClick={() => onOuvrir(m.request_id)}>Ouvrir le dossier</button>
            )}
          </section>
        )
      })()}
    </>
  )
}
